import React, { memo } from "react";
import { Position, Handle } from "reactflow";

import SourceOutlinedIcon from "@mui/icons-material/SourceOutlined";
import MediationRoundedIcon from "@mui/icons-material/MediationRounded";

const nodes = {
  source: { icon: <SourceOutlinedIcon style={{ color: "#00acb5" }} />, backgroundColor: "#00acb5" },
  target: { icon: <MediationRoundedIcon style={{ color: "#02c106" }} />, backgroundColor: "#02c106" },
};

export const Node = memo((node) => {
  const { data, type } = node;
  const { label, hasConnector } = data;
  const { icon, backgroundColor } = nodes[type] || nodes.source;

  return (
    <>
      {hasConnector && type === "source" && <Handle type="source" position={Position.Right} isConnectable={false} />}
      {hasConnector && type === "target" && <Handle type="target" position={Position.Left} isConnectable={false} />}

      <div
        className={`dndnode`}
        style={{
          border: `2px solid ${backgroundColor}`,
        }}
        draggable
      >
        {icon}
        <span className="dndnode-text">{label}</span>
      </div>
    </>
  );
});
